export default "__VITE_ASSET__52JF6Y$I__"